// extracted by mini-css-extract-plugin
export var bodySections = "_c0-8";
export var gray = "_c0-7";
export var green = "_c0-4";
export var iconContainer = "_c0-9";
export var iconWidgetContainer = "_c0-1";
export var phoneIcon = "_c0-2";
export var red = "_c0-5";
export var statusDot = "_c0-3";
export var widgetContainer = "_c0-0";
export var yellow = "_c0-6";